const HIDDEN_ROLES = new Set(["agency", "planner"]);

export const getGuestParties = (parties) => parties?.filter((p) => !HIDDEN_ROLES.has(p.role)) ?? [];

export const isAgencyUser = (user) => (user?.roles || []).includes("planner") && !!user?.organization_id;
